import { registerKeapFormElement } from './keap-forms-processing';
import { registerKeapEventElements, registerKeapHostingElement } from '@/hosting/keap-track';
import { processKeapLinks } from '@/hosting/keap-links';
import { processCalendly } from '@/hosting/calendly-appointments';
import hydrate from '@/hosting/ssr/hydrate';

(function () {
    registerKeapHostingElement();
    registerKeapFormElement();
    registerKeapEventElements();
    processKeapLinks();
    processCalendly();
}());

window.addEventListener('load', () => {
    hydrate();
});
